import { Divider, PageHeader } from 'antd';
import { resetCurrentWorkspace } from 'app-redux/actions/licensingAccounts.actions';
import { logout } from 'app-redux/actions/login.actions';
import { AppState } from 'app-redux/reducers';
import { getCurrentUser } from 'app-redux/selectors/accounts.selector';
import { getCurrentWorkspace } from 'app-redux/selectors/licensingAccounts.selector';
import {
  getCurrentOrg,
  hasLoadedOrgs,
  selectIsLoadingOrgs,
} from 'app-redux/selectors/orgs.selector';
import { IUserAccount } from 'core/accounts/models';
import { IWorkspace } from 'core/workspaces/models';
import { INavigationRouteProps } from 'core/navigation/models';
import first from 'lodash/first';
import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  fetchAllOrgs,
  setCurrentOrg,
} from '../../app-redux/actions/org.actions';
import { history, RoutePaths } from '../../core/history';
import { OrganizationDTO } from '../../core/orgs/models';
import { PageDTO, UUID } from '../../core/utils/BasicModels';
import { LanguageDropdown } from './LanguageDropdown';
import { LoginSection } from './LoginSection';
import './style.less';
import { getBrandLogo } from 'utils/BrandingUtils';
import { translationWrapper } from '../../utils/common-methods';
import { iff } from 'core/iff';
import { SettingsMenu } from '@cw-elements/settings-menu';
import { AvailableLanguages } from '@cw-elements/profile-dropdown/utils/contants';
import { ProfileDropdown } from '@cw-elements/profile-dropdown';
import { AppConstants } from 'core/app.constants';
import i18next from 'i18next';
import { setLocaleTempUsingCookies, setLocaleUsingCookies } from 'core/common-methods';
interface ContextBarProps extends INavigationRouteProps<{}> {
  currentOrg?: OrganizationDTO;
  isCurrentUserLoading?: boolean;
  currentUser?: IUserAccount;
  isLoadingOrgs: boolean;
  hasLoadedOrgs: boolean;
  currentWorkspace: IWorkspace | null;
  fetchOrgs: () => Promise<PageDTO<OrganizationDTO>>;
  setCurrentOrg: (orgId: UUID) => void;
  resetCurrentWorkspace: () => any;
  logoutUser?: () => any;
}

export const ContextBarComponent: React.FC<ContextBarProps> = (props) => {
  const { t } = translationWrapper(useTranslation());
  const [workspace, setWorkspace] =
    useState<IWorkspace | null>(null);
  useEffect(() => {
    if (!props.hasLoadedOrgs && !props.isLoadingOrgs && props.currentUser) {
      props.fetchOrgs().catch();
    }
  }, [props.hasLoadedOrgs, props.currentUser]);

  useEffect(() => {
    if (history.location.pathname === RoutePaths.WORKSPACES()) {
      setWorkspace(null);
    } else {
      setWorkspace(props.currentWorkspace);
    }
  }, [history.location.pathname, props.currentWorkspace]);

  const onBackClick = async () => {
    if (!props.currentUser) {
      return;
    }
    if (history.location.pathname !== RoutePaths.WORKSPACES()) {
      history.push({
        pathname: RoutePaths.WORKSPACES(),
        search: location.search,
      });
    }
  };
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  const [windowSize, setWindowSize] = useState(getWindowDimensions().width);
  React.useEffect(() => {
    function handleResize() {
      setWindowSize(getWindowDimensions().width);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const HeaderTitle = () => {
    return (
      <span>
        <Divider type='vertical' className='divider-header-logo'></Divider>
        <span className="breadcrumb-title-username">{t("global.title.accounts")}</span>
      </span>
    );
  };

  const getShortName = (name: any) => {
    if (isEmpty(name)) {
      return '';
    }
    const splitedNames = name.split(' ');
    const firstName: string = first(splitedNames) || '';
    const lastName: string = last(splitedNames) || '';
    if (splitedNames.length >= 2) {
      return `${firstName.charAt(0).toUpperCase()}${lastName
        .charAt(0)
        .toUpperCase()}`;
    }
    return firstName.charAt(0).toUpperCase();
  };

  const handleLogoutClick = () => {
    if (props.logoutUser) {
      props.logoutUser();
    }
  };

  const popoverContent = () => {
    const jobTitle = props?.currentUser?.job_title || '';
    return (
      <div className="user-profile-popup">
        <div className="user-profile-popup__inner_div">
          <div className="user-profile-popup__inner_div__title">
            {t('global.context_bar.text.account')}
          </div>
          <div>
          <div className="user-profile-popup__inner_div__content">
            <div className="user-profile-popup__inner_div__content__name_container">
              <div className="user-profile-popup__inner_div__content__name_container__name">
                {getShortName(props?.currentUser?.name)}
              </div>
            </div>
            <div className="user-profile-popup__inner_div__content__name">
              {props?.currentUser?.name}
               <div className='job-title-text'>
                 {iff(jobTitle.length > 0, t(`global.job_titles.${jobTitle}`), "")}
               </div>
            </div>
          </div>
          </div>
        </div>
        <Divider className="user-profile-popup__divider" />
        <div>
          <LanguageDropdown />
        </div>
        <Divider className="user-profile-popup__divider" />
        <div className="user-profile-popup__logout" onClick={handleLogoutClick}>
          {t('global.context_bar.text.log_out')}
        </div>
      </div>
    );
  };

  return useMemo(() => {
    if (!window.location.pathname.includes('/legaldocs') && !window.location.pathname.includes('/privacynote') && !window.location.pathname.includes('/privacypolicy')) {
      return (
      <>
        <PageHeader
          className="site-page-header"
          onBack={onBackClick}
          title={<HeaderTitle />}
          backIcon={<img style={{height:'50px'}} src={getBrandLogo()}></img>}
          extra={[
            <LoginSection key="" />,
            <>
              <SettingsMenu
                headerSelector=".site-page-header"
                orgId={props.currentOrg?.id}
                workspaceId={props.currentWorkspace?.id}
              />
              <Divider type="vertical" style={{ height: '20px' }}/>
              {
                <ProfileDropdown
                  availableLanguages={(AppConstants.SUPPORTED_LANGS.map(({value}) => value) as AvailableLanguages[])}
                  availableUnitSystems={[]}
                  onLogout={handleLogoutClick}
                  onLanguageChange={(lang) => {
                    localStorage.setItem('currentLanguage', lang);
                    i18next.changeLanguage(lang || 'en');
                    setLocaleTempUsingCookies(lang || 'en');
                    setLocaleUsingCookies(lang || 'en');
                  }}
                />
              }
            </>
          ]}
        />
        </>
      );
    }
    return <></>;
  }, [
    props.currentOrg,
    props.currentWorkspace,
    props.location.pathname,
    props.currentUser,
    props.isLoadingOrgs,
    workspace,
    localStorage.getItem('currentLanguage'),
    windowSize,
  ]);
};

const mapStateToProps = (
  state: AppState,
  ownProps: ContextBarProps,
): ContextBarProps => {
  return {
    ...ownProps,
    currentOrg: getCurrentOrg(state),
    isCurrentUserLoading: state.accounts.loading,
    currentUser: getCurrentUser(state),
    hasLoadedOrgs: hasLoadedOrgs(state),
    isLoadingOrgs: selectIsLoadingOrgs(state),
    currentWorkspace: getCurrentWorkspace(state),
  };
};

const mapDispatchToProps = (
  dispatch: any,
  ownProps: ContextBarProps,
): ContextBarProps => {
  return {
    ...ownProps,
    fetchOrgs: () => dispatch(fetchAllOrgs()),
    setCurrentOrg: (orgId: UUID) => dispatch(setCurrentOrg(orgId)),
    logoutUser: () => dispatch(logout()),
    resetCurrentWorkspace: () =>
      dispatch(resetCurrentWorkspace()),
  };
};

// @ts-ignore
export const ContextBar = withRouter(
  // @ts-ignore
  connect(mapStateToProps, mapDispatchToProps)(ContextBarComponent),
) as unknown as React.FC<{}>;
